import { FormControlLabel, Input, Box, FormHelperText } from '@mui/material';
import { FormControlTimeFieldProps, FormElementControlPropsType } from './index';

import styles from './FormTimeField.styles';
import React, { useEffect, useRef, useState } from 'react';
import useBundleTranslation from 'i18n';
import { useFormState } from 'react-hook-form';
import { FormComponentBuilder } from 'components/common/form/layout';

export default function FormTimeField({ controlProps }: FormElementControlPropsType<FormControlTimeFieldProps>) {
    const { t } = useBundleTranslation(['form_errors']);
    const inputRef = useRef<HTMLDivElement | null>(null);
    const [errorMessage, setErrorMessage] = useState('');
    const { errors } = useFormState({ control: controlProps.form.hookFormControl });
    const handleOnChange = (event: any) => {
        const value = event.target.value;

        if (!/[a-zA-Z]/.test(value)) {
            controlProps.form.hookFormSetValue(controlProps.name, value, { shouldDirty: true });
        }

        parseInt(value) <= 0 || value === '' ? setErrorMessage(t('IntVal_error_required')) : setErrorMessage('');
    };

    useEffect(() => {
        if (errors.hasOwnProperty('period_value')) {
            const message = errors['period_value']?.message ? errors['period_value'].message.toString() : '';
            setErrorMessage(message);
        } else {
            setErrorMessage('');
        }
    }, [errors?.period_value]);

    useEffect(() => {
        const input = inputRef.current?.getElementsByTagName('input').item(0);
        if (input) {
            input.setAttribute('data-test', `${controlProps.uid}_input`);
        }
    }, [inputRef]);

    return (
        <FormControlLabel
            sx={styles.root}
            name={controlProps.name}
            label={controlProps.label}
            control={
                <Box>
                    <Box sx={styles.inputField}>
                        <Input
                            ref={inputRef}
                            sx={{ maxWidth: 100 }}
                            name={controlProps.name}
                            onChange={handleOnChange}
                            value={controlProps.value}
                            data-test={controlProps.uid}
                            inputProps={{ 'data-1p-ignore': true }}
                        />
                        {controlProps.extraText && <Box sx={styles.extraText}>{controlProps.extraText}</Box>}
                    </Box>
                    {errorMessage && (
                        <FormHelperText
                            sx={{
                                color: 'error.main',
                            }}
                        >
                            {errorMessage}
                        </FormHelperText>
                    )}
                </Box>
            }
        />
    );
}
export class FormTimeFieldBuilder extends FormComponentBuilder {
    prepareProps(): FormControlTimeFieldProps {
        return {
            ...this.controlProps,
            extraText: this.elementProps.componentProps?.extraText ?? '',
        };
    }
}
